/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../api.service';
import { CashbackService } from '../../services/cashback.service';

@Component({
  selector: 'app-cashback-popup',
  templateUrl: './cashback-popup.component.html',
  styleUrls: ['./cashback-popup.component.scss']
})
export class CashbackPopupComponent {
  ref_by_name: any;
  isMobileExited = false;
  isCheckedProNumber = false;
  constructor(@Inject(PLATFORM_ID) private platformId: any, public _router: Router, private _actRouter: ActivatedRoute,public _as:AppService,public _cashback:CashbackService) {
  }
 
  mobileExist(event: any,form_type:string) {  
    const query = event.target.value.trim(); //remove white space
    if (query.length == 10 && (/^[0-9]+$/).test(query)) {
      
      const url = this._as.api_base_url + `renovarz/verification-v2/?mobile=${query}`;
      this._as.getRequest(url, true)
        .subscribe((res: any) => {
            this.ref_by_name = res.name;
            this.isMobileExited = true;
        }, (err: any) => {
          if(err){
            if(form_type=='pros'){
              this.isMobileExited = false;
              this.isCheckedProNumber = true;
            }
          }
        });
    }
  }
}
